// redux/slices/userSlice.js
import { createSlice } from "@reduxjs/toolkit";

let dashboard;
try {
  const stored = localStorage.getItem("dashboardDetails");
  dashboard = stored ? JSON.parse(stored) : null;
} catch (e) {
  dashboard = null;
}

const initialState = {
    user: JSON.parse(localStorage.getItem("userDetails")) || null,
    dashboard: dashboard,
    // dashboard: JSON.parse(localStorage.getItem("dashboardDetails")) || null,
};

const userSlice = createSlice({
    name: "user",
    initialState,
    reducers: {
        setUser: (state, action) => {
            state.user = action.payload;
            localStorage.setItem("userDetails", JSON.stringify(action.payload));
            // console.log('userDetails updated');
        },
        setDashboard: (state, action) => {
            state.dashboard = action.payload;
            localStorage.setItem("dashboardDetails", JSON.stringify(action.payload));
            // console.log('dashboardDetails updated');
        },
        // Optional: a combined setter
        setUserAndDashboard: (state, action) => {
            const { user, dashboard } = action.payload;
            state.user = user;
            state.dashboard = dashboard;
            localStorage.setItem("userDetails", JSON.stringify(user));
            localStorage.setItem("dashboardDetails", JSON.stringify(dashboard));
            // console.log('userDetails and dashboardDetails updated');
        },
        logout: (state) => {
            state.user = null;
            state.dashboard = null;
            localStorage.removeItem("userDetails");
            localStorage.removeItem("dashboardDetails");
            // console.log('User and dashboard cleared on logout');
        }
    },
});

export const { setUser, setDashboard, setUserAndDashboard, logout } = userSlice.actions;

export default userSlice.reducer;